// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filterIconWrap{width:35px;height:35px;background-color:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;padding:3px;box-shadow:0 1px 3px rgba(103,104,167,.4)}.selectedIcon{border:1.5px solid #4a669e}", ""]);
// Exports
module.exports = exports;
